export interface BlogPost {
    id: string;
    type: BlogPostType;
    slug: string;
    title: string;
    content: string;
    link: string;
    excerpt: string;
    createdAt: Date,
    updatedAt: Date,
}

export interface BlogPosts {
    count: number;
    totalCount: number;
    pages: number;
    page: number;
    posts: BlogPost[];
}

export interface BlogPostInput {
    type?: BlogPostType;
    id?: string;
    slug?: string;
    slugLocale?: boolean;
    categories?: number[];
    search?: string;
    limit?: number;
    page?: number;
    offset?: number;
    order?: BlogOrderType,
    orderBy?: string;
}

export enum BlogPostType {
    Post = 'post',
    Page = 'page'
}

export enum BlogOrderType {
    Ascending = 'asc',
    Descending = 'desc'
}